import { useEffect } from "react";
import { useSelector } from "react-redux";
import { COLOR_CONSTANTS } from "config/helpers/color_helper";

const ASSISTANT_URL = (
    process.env.REACT_APP_PRACTITIONER_ASSISTANT_URL || ""
).replace(/\/+$/, "");

const ALLOWED_USERS = (
    process.env.REACT_APP_PRACTITIONER_ASSISTANT_USERS || ""
)
    .split(",")
    .map((e) => e.trim().toLowerCase())
    .filter(Boolean);

const NokiAssistant = () => {
    const isUserLoggedIn = useSelector((state) => state?.auth?.isUserLoggedIn);

    const userEmail = useSelector(
        (state) => state?.auth?.userData?.resource?.email
    );
    const isAllowedUser =
        ALLOWED_USERS.length === 0 ||
        ALLOWED_USERS.includes((userEmail || "").trim().toLowerCase());

    useEffect(() => {
        if (!isUserLoggedIn || !isAllowedUser || !ASSISTANT_URL) return undefined;
        if (window.__nokiWidgetLoaded) return undefined;

        const script = document.createElement("script");
        script.src = `${ASSISTANT_URL}/widget.js`;
        script.defer = true;
        script.dataset.app = ASSISTANT_URL;
        script.dataset.title = "Noki Assistant";
        script.dataset.color = COLOR_CONSTANTS.PRIMARY;
        script.dataset.position = "left";
        script.dataset.greeting = "Hi! Ask me about your patients 👋";
        document.body.appendChild(script);

        return () => {
            if (window.NokiAssistant) window.NokiAssistant.destroy();
            script.remove();
        };
    }, [isUserLoggedIn, isAllowedUser]);

    return null;
};

export default NokiAssistant;
